<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { useSiteStore } from '~/stores/site.store';
import { LockIcon, GearIcon } from '../../design-system/icons/index';
import { ChevronRightIcon } from '@heroicons/vue/24/outline';
import { useAuthStore } from '~/stores/auth.store';
import ExternalIcon from '~/components/design-system/icons/ExternalIcon.vue';

const site = useSiteStore();
const auth = useAuthStore();
const loading = ref(true);
const { $t, $toggleChat } = useNuxtApp();

onMounted(async () => {
  loading.value = false;
});

function goToRG() {
  site.deactivateModal();
  auth.setAccountModalPage('responsible-gaming');
  auth.toggleAccountModal(true);
}

function goToWithdrawal() {
  site.deactivateModal();
  auth.setAccountModalPage('withdrawal');
  auth.toggleAccountModal(true);
}
</script>

<template>
  <LazyUserInterfaceGenericLoader v-if="loading" />
  <div v-else>
    <div class="mx-2">
      <div class="flex flex-col justify-center items-center flex-wrap pt-3">
        <div class="flex justify-center">
          <div class="border-gold-500 border-4 rounded-full p-2 flex">
            <LockIcon class="w-10 h-10 text-gold-500" />
          </div>
        </div>
        <div class="">
          <p class="my-3" v-html="$t('wager-limit-exceeded-body')" />
          <p class="mt-4 line-height-3">
            {{ $t('account-lock-restricted') }}
          </p>
          <p
            class="text-center mb-4 line-height-3"
            v-html="$t('only-permitted-access-withdrawal')"
          />
        </div>
      </div>
      <!-- Support Divs -->
      <!-- Live chat -->
      <div
        class="flex justify-between bg-base rounded-md mb-2 pl-3 cursor-pointer py-1"
        @click="$toggleChat()"
      >
        <div class="flex items-center mt-0.5 mb-0.5">
          <ExternalIcon class="w-6 mt-1 mr-3" icon-name="chat-support" />
          <p class="my-0 font-bold mr-1 line-height-1">{{ $t('chat') }}</p>
          <p class="my-0 line-height-1">{{ $t('to-live-support') }}</p>
        </div>
        <ChevronRightIcon
          class="w-4 dark:text-light-50 text-dark-700 mr-2 stroke-2 stroke-current"
        />
      </div>
      <!-- Responsible gaming page -->
      <div
        class="flex justify-between bg-base rounded-md mb-4 pl-3 cursor-pointer py-1"
        @click="goToRG()"
      >
        <div class="flex items-center mt-0.5 mb-0.5">
          <GearIcon
            class="!w-6 !h-6 mt-1 mr-3 dark:text-light-50 text-dark-700"
          />
          <p class="my-0 mr-1 line-height-1" v-html="$t('view-rg-page')" />
        </div>
        <ChevronRightIcon
          class="w-4 dark:text-light-50 text-dark-700 mr-2 stroke-2 stroke-current"
        />
      </div>
    </div>
    <div class="bg-base w-full px-2 py-1">
      <Button
        class="w-full my-2 justify-center"
        type="primary"
        @click="goToWithdrawal()"
      >
        {{ $t('go-to-withdrawal-page') }}
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
p {
  @apply text-dark-700 dark:text-light-50;
}
</style>
